// src/resources/reports/ReportAppPenetration/export.ts
//
// Achata o grupo (posto × 3 escopos) numa linha por posto × escopo, incluindo a
// linha "Todos" (totals) no topo — mesmo espírito do fillinByStationExport em
// ReportFillinByStation.jsx, que também inclui o agregado da rede na exportação.
import { formatNumber } from '../../../utils';
import {
  MetricSet, PenetrationDetailsData, RowScope, StationRow, metricSetFor,
} from './types';

const SCOPE_LABEL: Record<RowScope, string> = {
  [RowScope.App]: 'No app',
  [RowScope.Off]: 'Fora do app',
  [RowScope.Total]: 'Total da pista',
};

const pct = (value: number | null): string =>
  value === null ? '' : formatNumber(value * 100, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

const rowsForStation = (row: StationRow) => ([RowScope.App, RowScope.Off, RowScope.Total]).map(scope => {
  const metrics: MetricSet = metricSetFor(row, scope);
  // Participação só faz sentido na linha "No app" — nas demais linhas, campos vazios.
  const isApp = scope === RowScope.App;

  return {
    posto: row.name,
    escopo: SCOPE_LABEL[scope],
    valor: metrics.value,
    litros: metrics.volume,
    abastecimentos: metrics.fillins,
    descontos: metrics.discounts ?? '',
    ticket_medio: metrics.avgTicket !== null ? formatNumber(metrics.avgTicket, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
    volume_medio: metrics.avgVolume !== null ? formatNumber(metrics.avgVolume, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '',
    participacao_valor: isApp ? pct(row.share.value) : '',
    participacao_litros: isApp ? pct(row.share.volume) : '',
    participacao_abastecimentos: isApp ? pct(row.share.fillins) : '',
  };
});

// Assinatura solta (data: any[]) de propósito — mesmo padrão do giftClubExporter
// em ReportGiftClub.tsx: o preExport do CustomExportButton tipa DataType como
// Record<string,string>, mas os relatórios existentes exportam número cru.
export const penetrationExporter = async (data: any[]): Promise<any[]> => {
  const details = data?.[0] as PenetrationDetailsData | undefined;
  if (!details) return [];

  return [details.totals, ...details.byStation].flatMap(rowsForStation);
};
